module.exports = "pegasus_template/assets/fake-template.png";